/* tslint:disable */

declare var Object: any;
export interface ERPinternalInventoryRequisitionReturnInterface {
  "id"?: number;
}

export class ERPinternalInventoryRequisitionReturn implements ERPinternalInventoryRequisitionReturnInterface {
  "id": number;
  constructor(data?: ERPinternalInventoryRequisitionReturnInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPinternalInventoryRequisitionReturn`.
   */
  public static getModelName() {
    return "ERPinternalInventoryRequisitionReturn";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPinternalInventoryRequisitionReturn for dynamic purposes.
  **/
  public static factory(data: ERPinternalInventoryRequisitionReturnInterface): ERPinternalInventoryRequisitionReturn{
    return new ERPinternalInventoryRequisitionReturn(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPinternalInventoryRequisitionReturn',
      plural: 'ERPinternalInventoryRequisitionReturns',
      path: 'ERPinternalInventoryRequisitionReturns',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPinternalInventoryRequisitionReturn.ts